import { useState } from "react";
import { useApp } from "../context/AppContext";
import DetailView from "./DetailView";
import SemanticsView from "./SemanticsView";

const TABS = [
  { key: "view", label: "Перегляд", icon: "📊" },
  { key: "import", label: "Імпорт CSV", icon: "📥" },
];

export default function SemanticsCombinedView() {
  const { dark, t, stitle, muted, getStore, activeId } = useApp();
  const store = getStore(activeId);
  const hasClusters = (store.clusters || []).length > 0;
  const [tab, setTab] = useState(hasClusters ? "view" : "import");

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div>
          <h2 style={{ ...stitle, margin: 0 }}>Семантичне ядро</h2>
          <p style={{ ...muted, margin: "4px 0 0", fontSize: 13 }}>Імпорт, перегляд та аналіз кластерів</p>
        </div>
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
        {TABS.map(tb => (
          <button key={tb.key} onClick={() => setTab(tb.key)}
            disabled={tb.key === "view" && !hasClusters}
            style={{
              padding: "8px 20px", borderRadius: 8, border: "none", cursor: tb.key === "view" && !hasClusters ? "default" : "pointer",
              opacity: tb.key === "view" && !hasClusters ? 0.4 : 1,
              background: tab === tb.key ? "#6366f1" : dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)",
              color: tab === tb.key ? "#fff" : t.text,
              fontWeight: tab === tb.key ? 700 : 500, fontSize: 13, fontFamily: "inherit",
              display: "flex", alignItems: "center", gap: 6, transition: "all .15s",
            }}>
            <span>{tb.icon}</span> {tb.label}
          </button>
        ))}
      </div>
      {tab === "view" && <SemanticsView />}
      {tab === "import" && <DetailView />}
    </div>
  );
}
